import { render, staticRenderFns } from "./Spisanie.vue?vue&type=template&id=f6538190&scoped=true&"
import script from "./Spisanie.vue?vue&type=script&lang=js&"
export * from "./Spisanie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6538190",
  null
  
)

export default component.exports